import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';
import { useState, useEffect } from 'react';
import classnames from 'classnames';
import { useRouter } from 'next/router';
import Link from 'next/link';
import moment from 'moment';

import { Button } from '@/components/common/Button';
import { NoData } from '@/components/common/Empty';

import styles from './ListNav.module.scss';

function ListNav({
  defaultlist, tab, className, listHook,
}) {
  const router = useRouter();
  const { locale, query } = router;
  const { t, i18n } = useTranslation('pages', { keyPrefix: 'news.announcement' });
  const [page, setPage] = useState(1);
  const { data, end } = listHook({ lang: locale, page });

  const [list, setList] = useState();
  const listData = list || defaultlist || [];

  useEffect(() => {
    if (data) {
      setList((prevlist) => {
        const newList = [...(prevlist || [])];
        newList.push(...data.filter((item) => newList.every((i) => i.id !== item.id)));
        return newList;
      });
    }
  }, [data]);

  const id = query?.id || (list || defaultlist)?.[0]?.id;

  return (
    <nav className={classnames(styles.container, { [className]: !!className })}>
      {listData.length ? (
        listData.map((item) => (
          <li key={item.id} className={classnames({ [styles.active]: Number(id) === Number(item.id) })}>
            <Link href={`/news${tab}/${item.id}`}>
              <a href={`/news${tab}/${item.id}`}>
                <div>
                  <span className={styles.title}>
                    {item.type !== undefined ? `【${t(`type.${item.type}`)}】` : ''}
                    {item?.title}
                  </span>
                  <span className={styles.time}>
                    {
                      i18n.language === 'en' ? moment(item.time || item.date).format('[Published on] MMM Do, YYYY')
                        : (
                          moment(item.time || item.date).format('YYYY年MM月DD日[发布]')
                        )
                    }
                  </span>
                </div>
              </a>
            </Link>
          </li>
        ))
      ) : (
        <div className={styles.empty}>
          <NoData />
        </div>
      )}
      {tab !== '/stories' || end ? null : (
        <Button variant="plane" onClick={() => setPage((prevPage) => prevPage + 1)}>
          {t('loadmore')}
        </Button>
      )}
    </nav>
  );
}

ListNav.propTypes = {
  defaultlist: PropTypes.arrayOf(PropTypes.instanceOf(Object)),
  className: PropTypes.string,
  tab: PropTypes.string,
  listHook: PropTypes.func,
};
ListNav.defaultProps = {
  defaultlist: [],
  className: '',
  tab: '',
  listHook: () => null,
};

export default ListNav;
